import { updateCredits } from '../actions/updateCredits';
import { scrollToChatBottom } from '../actions/scrollToChatBottom';
import { initMessageActions } from './chatContent';
import { chatDebugLog } from '../helpers/chatDebug';

function getRenderedConversation(renderHtml) {
    const $renderWrapper = $('<div>').html(renderHtml);
    const $renderedChatForm = $renderWrapper.find('.g-chatform').first();
    const $scope = $renderedChatForm.length ? $renderedChatForm : $renderWrapper;

    return $scope.find('.g-chatform-content').first();
}

function getVisibleMessages($content) {
    return $content.find('.g-chatform-message').filter(function () {
        const inlineStyle = String($(this).attr('style') || '')
            .replace(/\s+/g, '')
            .toLowerCase();

        return !inlineStyle.includes('display:none');
    });
}

function revealConversationMessages($chatForm, options = {}) {
    if (options.animate !== true) {
        return Promise.resolve(false);
    }

    const $messages = $chatForm
        .find('.g-chatform-content .g-chatform-message[data-conversation-state-reveal="true"]');
    let sequence = Promise.resolve();

    $messages.each(function (index, element) {
        const $message = $(element);
        const $actions = $message.find('.g-chatform-message-actions');
        $actions.hide();

        sequence = sequence.then(function () {
            return new Promise(function (resolve) {
                $message.stop(true, true).fadeIn(index === 0 ? 220 : 260, function () {
                    $message.removeAttr('data-conversation-state-reveal');
                    $actions.fadeIn(180);
                    resolve();
                });
            });
        });
    });

    return sequence.then(function () {
        return $messages.length > 0;
    });
}

export function replaceConversationState($chatForm, response, options = {}) {
    const payload = response?.data || response || {};
    const renderHtml = payload.render;
    const traceId = payload.roleplay_trace_id || payload.trace_id || '';

    if (!$chatForm?.length || typeof renderHtml !== 'string' || renderHtml.trim() === '') {
        const error = { message: 'Conversation response is missing render state.', traceId };
        console.error('[conversation-state] rejected', error);
        return Promise.reject(error);
    }

    const $nextContent = getRenderedConversation(renderHtml);
    const $currentContent = $chatForm.find('.g-chatform-content').first();
    if (!$nextContent.length || !$currentContent.length) {
        const error = { message: 'Conversation content container was not found.', traceId };
        console.error('[conversation-state] rejected', error);
        return Promise.reject(error);
    }

    const $nextMessages = getVisibleMessages($nextContent);
    if (options.animate === true) {
        $nextMessages
            .attr('data-conversation-state-reveal', 'true')
            .css('display', 'none');
    }

    const chatId = $chatForm.attr('id') || 'gc-shell-chat';
    const nextState = {
        session_token: payload.session_token || $chatForm.attr('data-session-token') || '',
        roleplay_scenario: payload.roleplay_scenario || '',
        message_count: $nextMessages.length,
        updated_at: Date.now(),
    };

    document.dispatchEvent(new CustomEvent('growtypeChatConversationStateWillChange', {
        detail: { chatForm: $chatForm, previousState: window.growtype_chat?.[chatId]?.conversation_state || null, nextState },
    }));

    window.growtype_chat = window.growtype_chat || {};
    window.growtype_chat[chatId] = window.growtype_chat[chatId] || {};
    window.growtype_chat[chatId].conversation_state = nextState;

    chatDebugLog('chatContent', '[conversation-state] apply', { traceId, chatId, ...nextState });
    $currentContent.html($nextContent.html());
    updateCredits(payload.existing_credits);
    initMessageActions($chatForm);

    return revealConversationMessages($chatForm, options).then(function () {
        if (options.scrollToBottom === true) {
            scrollToChatBottom(200, true);
        }

        document.dispatchEvent(new CustomEvent('growtypeChatConversationStateChanged', {
            detail: { chatForm: $chatForm, state: nextState },
        }));
        document.dispatchEvent(new CustomEvent('growtypeChatContentRendered', {
            detail: { contentWrapper: $chatForm, messages: [] },
        }));

        return { chatForm: $chatForm, state: nextState };
    });
}

function getConversationRenderArgs($chatForm, overrides = {}) {
    let renderArgs = {};
    const storedArgs = $chatForm.attr('data-chat-render-args')
        || $chatForm.find('.g-chatform-content-render').first().attr('data-args')
        || '';

    if (storedArgs) {
        try {
            renderArgs = JSON.parse(storedArgs);
        } catch (error) {
            console.error('[conversation-state] failed to parse render args', error);
        }
    }

    const currentUrl = new URL(window.location.href, window.location.origin);
    const pathnameParts = currentUrl.pathname.split('/').filter(Boolean);
    const requestArgs = {
        ...renderArgs,
        character_slug: renderArgs.character_slug || pathnameParts[pathnameParts.length - 1] || '',
        session_token: $chatForm.attr('data-session-token') || renderArgs.session_token || '',
        user_token: $chatForm.attr('data-user-token') || renderArgs.user_token || '',
        ...overrides,
        omit_client_state_payload: true,
    };

    delete requestArgs.available_backgrounds;
    delete requestArgs.bot_profile;

    return requestArgs;
}

export function refreshConversationState($chatForm, overrides = {}, options = {}) {
    const requestArgs = getConversationRenderArgs($chatForm, overrides);

    return new Promise((resolve, reject) => {
        jQuery.ajax({
            url: growtype_chat_ajax.url,
            type: 'post',
            data: {
                action: 'chat_content_render',
                args: JSON.stringify(requestArgs),
                nonce: growtype_chat_ajax.nonce,
            },
            success(response) {
                replaceConversationState($chatForm, response, options)
                    .then(resolve)
                    .catch(reject);
            },
            error: reject,
        });
    });
}
